import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack } from '@mui/material';
import SearchableLawFirmSelect from '@/components/SearchableLawFirmSelect';
import { useLawFirmContext } from '@/hooks/useLawFirmContext';

interface Props {
    open: boolean;
    onClose(): void;
}

export default function LawFirmSwitchDialog({ open, onClose }: Props) {
    const { myLawFirmId, myLawFirmName, selectedLawFirmId, setSelectedLawFirmId } =
        useLawFirmContext();

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
            <DialogTitle>Switch Law Firm</DialogTitle>
            <DialogContent>
                <Stack spacing={2} sx={{ pt: 1 }}>
                    <SearchableLawFirmSelect
                        value={selectedLawFirmId}
                        myLawFirmId={myLawFirmId}
                        myLawFirmName={myLawFirmName}
                        excludeLawFirmId={myLawFirmId}
                        onChange={setSelectedLawFirmId}
                    />
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Close</Button>
            </DialogActions>
        </Dialog>
    );
}
